import ADDRESS from '@/abi/address';

export const CHAIN_ID = '0x61';
export const CHAIN_ID_NUMBER = 97;
export const RPC = {
  56: "https://bsc-dataseed.binance.org/",
  97: "https://data-seed-prebsc-1-s1.binance.org:8545/",
};


export const CHAINs = {
  '97':  {
    method: 'wallet_addEthereumChain',
    params: [
      {
        chainId: '0x61', // 97
        chainName: 'BNB Smart Chain Testnet',
        rpcUrls: ['https://data-seed-prebsc-1-s1.binance.org:8545/'],
        nativeCurrency: {
          name: 'BNB',
          symbol: 'BNB',
          decimals: 18
        },
        blockExplorerUrls: ['https://testnet.bscscan.com/']
      }
    ],
  },

  '56':  {
    method: 'wallet_addEthereumChain',
    params: [
      {
        chainId: '0x38', // 56
        chainName: 'BSC Network',
        rpcUrls: [
          'https://bsc-dataseed1.binance.org',
          'https://bsc-dataseed2.binance.org',
          'https://bsc-dataseed3.binance.org',
          'https://bsc-dataseed4.binance.org',
          'https://bsc-dataseed1.defibit.io',
          'https://bsc-dataseed2.defibit.io',
          'https://bsc-dataseed3.defibit.io',
          'https://bsc-dataseed4.defibit.io',
          'https://bsc-dataseed1.ninicoin.io',
          'https://bsc-dataseed2.ninicoin.io',
          'https://bsc-dataseed3.ninicoin.io',
          'https://bsc-dataseed4.ninicoin.io',
          'wss://bsc-ws-node.nariox.org',
        ],
        nativeCurrency: {
          name: 'Binance Chain Native Token',
          symbol: 'BNB',
          decimals: 18,
        },
        blockExplorerUrls: ['https://bscscan.com']
      }
    ],
  }
}

export const LST_TOKEN_IMPORT = [
  {
    address: ADDRESS.USDT_ADDRESS,
    symbol: 'USDT',
    key: 'usdt',
    decimals: 18,
    image: '',
    iconWeb: require('@/assets/icons/usdt.svg'),
  },
]
